export const css = {
    root: '_3fJw-q_m',
    ' _key': 'apic-theme/apic/variants/cic2'
};
export default css;
